import { styled } from '@moleculeone/ui';
import { chunk } from 'lodash';

import { ReagentTag } from './ReagentTag';
import { COMPOUND_NAME_FROM_SMILES } from './compounds';

const ReagentChunk = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
});

export const chunkConditions = (conditions: Record<string, string | number>) => {
  const visibleConditions = conditions
    ? Object.entries(conditions)
        .filter(([key, value]) => value && value !== 'None')
        .map(([key, value]) => {
          const compoundName = COMPOUND_NAME_FROM_SMILES[value];
          return [
            key,
            {
              text: compoundName ?? value,
              smiles: compoundName && (value as string),
            },
          ] as const;
        })
    : [];

  const [firstConditionChunk = [], secondConditionChunk = []] = chunk(
    visibleConditions,
    Math.ceil(visibleConditions.length / 2)
  );

  const firstConditionsChunk = (
    <ReagentChunk>
      {firstConditionChunk.map(([key, value]) => (
        <ReagentTag key={key} condition={key} fullWidth={true} {...value} />
      ))}
    </ReagentChunk>
  );
  const secondConditionsChunk = (
    <ReagentChunk>
      {secondConditionChunk.map(([key, value]) => (
        <ReagentTag key={key} condition={key} fullWidth={true} {...value} />
      ))}
    </ReagentChunk>
  );

  return { firstConditionsChunk, secondConditionsChunk };
};
